import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ViewChild,
  OnInit,
  ElementRef,
  Input,
  Renderer2,
  HostListener,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

import { Platform } from '@angular/cdk/platform';
import { Asset } from '../../../graphql/generated/generated-types';
import { AssetPreviewPipe } from '../../pipes/asset-preview.pipe';
import { NgOptimizedImage } from '@angular/common';
import { ProductImageWrapperComponent } from '../product/product-image-wrapper/product-image-wrapper.component';

export enum GalleryThumbnailsLayout {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}
@Component({
  selector: 'app-gallery',
  standalone: true,
  imports: [AssetPreviewPipe, NgOptimizedImage, ProductImageWrapperComponent],
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GalleryComponent implements OnInit {
  @ViewChild('gallerySlider') gallerySwiperElement!: ElementRef;
  @ViewChild('thumbnailsSlider') thumbnailsSwiperElement!: ElementRef;

  @Input() gridThumbnails: boolean = false;
  @Input() swiperThumbnails: boolean = true;

  @Input() initialGallerySlide: number = 0;
  @Input() activeGallerySlide: number = 0;
  @Input() showImageExplanation: boolean = false;

  public gallerySwiper!: any;
  public thumbnailsSwiper!: any;

  public thumbnailsSwiperDirection: GalleryThumbnailsLayout =
    GalleryThumbnailsLayout.Horizontal;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (this.platform.isBrowser) {
      this.changeGalleryLayout(event.target.innerWidth);
    }
  }

  @Input() images: Asset[] = [];

  constructor(
    private renderer: Renderer2,
    private platform: Platform,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.platform.isBrowser) {
      this.changeGalleryLayout(window.innerWidth);
      this.cdr.markForCheck();
    }
  }

  ngAfterViewInit() {
    this.gallerySwiper = this.gallerySwiperElement.nativeElement.swiper;
    this.thumbnailsSwiper = this.thumbnailsSwiperElement.nativeElement.swiper;
    this.listenToSwiperGallerySlideChanges();
    this.listenToSwiperThumbnailsSlideChanges();
    this.cdr.markForCheck();
  }

  private changeGalleryLayout(width: number) {
    if (width <= 767) {
      this.thumbnailsSwiperDirection = GalleryThumbnailsLayout.Vertical;
      this.cdr.markForCheck();
    } else {
      this.thumbnailsSwiperDirection = GalleryThumbnailsLayout.Horizontal;
      this.cdr.markForCheck();
    }
  }

  public listenToSwiperGallerySlideChanges() {
    this.renderer.listen(
      this.gallerySwiperElement.nativeElement,
      'swiper-slidechange',
      (event: any) => {}
    );
  }

  public listenToSwiperThumbnailsSlideChanges() {
    this.renderer.listen(
      this.thumbnailsSwiperElement.nativeElement,
      'swiper-thumbnails-slidechange',
      (event: any) => {}
    );
  }

  public changeActiveGallerySlide(index: number) {
    // this.SwiperEvents. slideChange(this.gallerySwiper as Swiper)
    this.gallerySwiper?.slideTo(index);
  }

  public swipeGalleryNext() {
    this.gallerySwiper?.slideNext();
  }

  public swipeGalleryPrev() {
    this.gallerySwiper?.slidePrev();
  }

  public changeActiveThumbnailsSlide(index: number) {
    this.thumbnailsSwiper?.slideTo(index);
  }

  public swipeThumbnailsNext() {
    this.thumbnailsSwiper?.slideNext();
  }

  public swipeThumbnailsPrev() {
    this.thumbnailsSwiper?.slidePrev();
  }
}
